import { create } from "zustand";

type Store = {
  isOpen: boolean;
  /**
   * Where to land once the session is active. `null` keeps the user on the
   * current page — the caller is responsible for refreshing it.
   */
  redirectUrl: string | null;
};

type Actions = {
  openAuthDialog: (redirectUrl?: string | null) => void;
  closeAuthDialog: () => void;
};

export const useAuthDialogStore = create<Store & Actions>()((set) => ({
  isOpen: false,
  redirectUrl: null,
  openAuthDialog: (redirectUrl = null) => set({ isOpen: true, redirectUrl }),
  closeAuthDialog: () => set({ isOpen: false, redirectUrl: null }),
}));
